<template>
  <div>
    <service-quest-list
      :param="{ status: 1 }"
      :category="1"
      :canNew="true"
    ></service-quest-list>
  </div>
</template>

<script>
import ServiceQuestList from './list'

export default {
  components: { ServiceQuestList },
}
</script>